import vueWrapper from "../../utils/vue-wrapper"
import app from './app.vue';
import commonStore from '../global/common-store'

export default () => {
  vueWrapper(app, "pdp-first-fold", "#pdpFirstFoldData", commonStore, true);
}